var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 230,
    height: 230,
    rx: 10,
    fill: "#E8F7FF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 83,
    width: 109,
    height: 64,
    rx: 10,
    fill: "#89CEFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7071067690849304,-0.7071067690849304,0.7071067690849304,0.7071067690849304,-38.57296430668066,73.32559675470839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.225341796875,83.2244873046875L74.903201796875,138.7074873046875C75.096391796875,140.5952873046875,76.589401796875,142.0874873046875,78.477291796875,142.2796873046875L134.27884179687499,147.9604873046875L69.225341796875,83.2244873046875Z",
    fill: "#6B9DFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.385531796875,75.1711173046875L66.240931796875,83.5298983046875L71.918791796875,139.0128873046875Q72.499411796875,144.6865873046875,78.173451796875,145.2642873046875L142.392241796875,151.8019873046875L65.385531796875,75.1711173046875ZM74.903201796875,138.7074873046875L69.225341796875,83.2244873046875L130.903241796875,144.6013873046875L134.27884179687499,147.9604873046875L129.541141796875,147.47818730468748L78.477291796875,142.2796873046875C76.589401796875,142.0874873046875,75.096391796875,140.5952873046875,74.903201796875,138.7074873046875Z",
    fillRule: "evenodd",
    fill: "#E8F7FF",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c902f3ae6af6f8e6a657db2a5ac5b7f9.svg";
export { ForwardRef as ReactComponent };